import { useMemo } from 'react';
import { useProfitIqContext } from '../context/ProfitIqContext';

/** The date window every tab shares. */
export function useDateRange() {
  const { range, setRange, customDays, customLabel, month, setMonth } =
    useProfitIqContext();
  return { range, setRange, customDays, customLabel, month, setMonth };
}

/** Online orders vs imported CSV. Never combined. */
export function useDataMode() {
  const { dataMode, setDataMode } = useProfitIqContext();
  return { dataMode, setDataMode };
}

/** Whether the cost editors write to the selected month or the defaults template. */
export function useCostTarget() {
  const { costTarget, setCostTarget } = useProfitIqContext();
  return {
    costTarget,
    setCostTarget,
    editingDefaults: costTarget === 'defaults',
  };
}

/**
 * The analytics params implied by the current date-range selection and the
 * browser's data mode. The mode is part of the query key, so switching it
 * refetches every read.
 */
export function useAnalyticsParams() {
  const { range, customDays, month } = useDateRange();
  const { dataMode } = useDataMode();
  return useMemo(
    () => ({ range, customDays, month, dataMode }),
    [customDays, dataMode, month, range]
  );
}
